import './App.css';

function App() {
  return (
    <div className="App">
      <h1>ITM Marketing & Services Privacy Policy</h1>
      <p>This Privacy Policy was last modified on 20th May 2015.</p>
      <p><a href="http://www.itmms.co.uk">ITM Marketing & Services Limited</a> operates Apple iOS Apps and Android Apps. This page informs you of our policies regarding the collection, use and disclosure of Personal Information we receive from users of our Apps.</p>
      <p>We use your Personal Information only for provising and improving the Apps. By using our Apps you agree to the collection and use of information in accordance with this policy.</p>
      <h3>Information Collection And Use</h3>
      <p>While using our Apps you are requested to send us your device registration number to allows our Apps to receive messages (Push Messages) from us. Other information are sent to Apple in case of crashes of the Apps.</p>
      <h3>Log Data</h3>
      <p>We don't collect any other information except the registration number to allows us to send you messages. This registration number will never be given to any other company and it will be kept in our server factory.</p>
      <h3>Security</h3>
      <p>The security of your Personal Information is important to us, but remember that no method of transmission over the Internet, or method of electronic storage, id 100% secure. While we strive to use commercial acceptable means to protect your Personal Information, we cannot garantee its absolute security.</p>
      <h3>Changes To This Privacy Policy</h3>
      <p>ITM Marketing & Services may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this site. You are advised to review this Privacy Policy periodically for any changes.</p>
      <h3>Contact Us</h3>
      <p>If you have any questions about this Privacy Policy, please contact us.</p>
    </div>
  );
}

export default App;
